// Generated from /Users/zhongboda/Desktop/导出/赵姐/zhike本地表结构.sql
// Do not edit manually unless the schema source changes.

const DB_FIELD_LENGTH_MAP = {
  "agent_message": {
    "content_summary": 500,
    "model": 128,
    "provider": 64,
    "role": 20
  },
  "agent_news": {
    "message_type": 50,
    "source_field": 255,
    "title": 255
  },
  "agent_risk_warning": {
    "risk_level": 20,
    "scene_group": 100,
    "scene_name": 255,
    "source_field": 255,
    "title": 255,
    "warning_type": 100
  },
  "agent_session": {
    "current_trace_id": 64,
    "default_model": 128,
    "default_provider": 64,
    "latest_answer_summary": 500,
    "status": 32,
    "title": 200
  },
  "agent_sql_audit_log": {
    "candidate_tables": 1000,
    "status": 32,
    "trace_id": 64,
    "validation_reason": 1000
  },
  "agent_step": {
    "category": 64,
    "error_code": 64,
    "error_message": 500,
    "risk_level": 16,
    "skill_code": 64,
    "skill_name": 128,
    "step_status": 32,
    "step_type": 32,
    "thought_summary": 1000,
    "trace_id": 64
  },
  "ai_conversation": {
    "conversation_type": 32,
    "title": 255
  },
  "ai_file_text": {
    "content_hash": 64
  },
  "ai_message": {
    "error_code": 100,
    "error_message": 500,
    "model": 100,
    "provider": 50,
    "role": 20
  },
  "ai_message_file": {
    "file_name": 255,
    "file_type": 20,
    "mime_type": 100
  },
  "ai_token_usage": {
    "model": 100,
    "provider": 50,
    "scene_code": 100
  },
  "bill_template": {
    "bill_type": 100,
    "remark": 1000,
    "template_name": 255
  },
  "change_table_data": {
    "table_url": 200
  },
  "code_generate": {
    "format": 20,
    "prefix_code": 5,
    "remark": 500
  },
  "company": {
    "company_address": 64,
    "company_name": 50,
    "contact_way": 100,
    "creator": 64,
    "modifier": 64,
    "remark": 500,
    "status": 1
  },
  "company_general_setting": {
    "company_logo_url": 500,
    "daily_report_time": 8,
    "weekly_report_time": 8
  },
  "company_general_setting_message": {
    "default_value": 255,
    "message_desc": 1000,
    "message_prompt": 255,
    "message_title": 255,
    "message_type": 50,
    "related_user": 1000,
    "remark": 1000
  },
  "company_risk_warning_setting": {
    "default_value": 255,
    "message_prompt": 1000,
    "message_title": 255,
    "push_position": 255,
    "related_user": 1000,
    "remark": 1000,
    "risk_level": 20,
    "scene_group": 100,
    "scene_name": 255,
    "trigger_time_desc": 255,
    "warning_type": 100
  },
  "config": {
    "config_key": 100,
    "config_name": 100,
    "config_type": 1,
    "config_value": 500,
    "creator": 64,
    "modifier": 64,
    "remark": 500
  },
  "customer": {
    "address": 500,
    "company_area": 255,
    "company_email": 255,
    "company_fax": 64,
    "company_phone": 64,
    "company_zipcode": 32,
    "country": 100,
    "customer_code": 64,
    "customer_company_name_cn": 255,
    "customer_company_name_en": 255,
    "customer_nature_ids": 500,
    "customer_short_name": 255,
    "customer_stage": 255,
    "customer_tag_ids": 500,
    "linkedin": 500,
    "main_business": 1000,
    "remark": 1000,
    "tax_no": 128,
    "unified_social_credit_code": 64,
    "website_url": 500
  },
  "customer_contact": {
    "backup_email": 255,
    "communication_hobby": 500,
    "decision_authority": 100,
    "department": 100,
    "dietary_hobby": 500,
    "email": 255,
    "family_status": 500,
    "facebook": 500,
    "linkedin": 500,
    "mic": 255,
    "mobile": 50,
    "name": 100,
    "other_remark": 1000,
    "personal_hobby": 500,
    "phone": 50,
    "position": 100,
    "wechat": 255,
    "whatsapp": 100
  },
  "customer_document": {
    "doc_format": 50,
    "doc_name": 255,
    "remark": 1000
  },
  "customer_follow_up": {
    "attachment_ids": 1000,
    "follow_up_subject": 255,
    "follow_up_type": 100,
    "related_product_code": 100,
    "related_project_code": 100,
    "related_quote_code": 100,
    "related_task_order_code": 100,
    "source_key": 64
  },
  "customer_lead": {
    "address": 500,
    "company_background": 1000,
    "company_linkedin": 500,
    "company_name": 255,
    "company_property": 255,
    "company_size": 255,
    "contact_name": 255,
    "country": 100,
    "decision_authority": 255,
    "department": 255,
    "email": 255,
    "lead_name": 255,
    "lead_source": 255,
    "lead_stage": 50,
    "facebook": 500,
    "linkedin": 500,
    "mic": 255,
    "mobile": 50,
    "nickname": 255,
    "phone": 50,
    "position": 255,
    "remark": 1000,
    "website_url": 500,
    "whatsapp": 100
  },
  "customer_lead_company_judge": {
    "company_name": 255,
    "company_size": 100,
    "country": 100,
    "industry": 255,
    "judge_result": 10,
    "keyword": 255,
    "linkedin_url": 500,
    "model": 100,
    "provider": 100,
    "remark": 500,
    "website": 500
  },
  "customer_lead_follow_up": {
    "follow_up_type": 100,
    "remark": 1000
  },
  "customer_level": {
    "level_name": 255,
    "remark": 1000
  },
  "customer_pool_flow": {
    "flow_reason": 500,
    "flow_type": 32,
    "remark": 500
  },
  "customer_stage": {
    "remark": 1000,
    "stage_name": 255
  },
  "customer_tag": {
    "remark": 1000,
    "tag_color": 50,
    "tag_name": 255,
    "tag_type": 100
  },
  "dept": {
    "ancestors": 500,
    "creator": 64,
    "dept_name": 64,
    "modifier": 64,
    "remark": 255
  },
  "dict_data": {
    "creator": 64,
    "css_class": 100,
    "dict_label": 100,
    "dict_type": 100,
    "dict_value": 100,
    "en_name": 200,
    "fr_name": 200,
    "is_default": 1,
    "list_class": 100,
    "mgl_name": 200,
    "modifier": 64,
    "remark": 500,
    "status": 1
  },
  "dict_type": {
    "creator": 64,
    "dict_name": 100,
    "dict_type": 100,
    "modifier": 64,
    "remark": 500,
    "status": 1
  },
  "file_db": {
    "bus_type": 50,
    "cos_key": 400,
    "file_name": 200,
    "file_type": 20
  },
  "history_mail_sync": {
    "email": 50,
    "email_key": 50,
    "folder": 20,
    "folder_type": 16,
    "remote_folder": 255
  },
  "history_mail_sync_mq": {
    "folder": 100,
    "folder_type": 16,
    "remote_folder": 255,
    "user_email": 255
  },
  "holiday_calendar": {
    "holiday_name": 100
  },
  "inquiry": {
    "inquiry_name": 255,
    "inquiry_no": 64,
    "inquiry_source": 100,
    "inquiry_tag_ids": 500,
    "inquiry_match_degree": 100,
    "target_purchase_qty": 255
  },
  "inquiry_follow_record": {
    "attachment_ids": 1000,
    "summary": 1000
  },
  "inquiry_setting": {
    "param_color": 32,
    "param_name": 128,
    "remark": 1000
  },
  "internal_quote": {
    "internal_lead_time": 255,
    "internal_packaging_requirement": 255,
    "internal_payment_method": 255,
    "internal_quote_no": 64,
    "internal_validity_period": 255,
    "price_total": 255,
    "price_unit": 64
  },
  "internal_quote_detail": {
    "custom_field1": 255,
    "custom_field2": 255,
    "custom_field3": 255,
    "custom_field4": 255,
    "custom_field5": 255,
    "custom_field6": 255,
    "file_path": 1024,
    "packaging_transport_price": 255,
    "raw_material_price": 255
  },
  "internal_quote_other_fee": {
    "fee_desc": 1024,
    "fee_name": 255,
    "fee_remark": 1024
  },
  "invoice": {
    "currency": 32,
    "customer_address": 500,
    "customer_company_name": 255,
    "customer_phone": 64,
    "delivery_date": 255,
    "delivery_time": 255,
    "incoterms": 255,
    "invoice_no": 64,
    "invoice_time": 255,
    "invoice_type": 64,
    "po_id": 255,
    "quote_id": 255,
    "receiver_address": 500,
    "receiver_name": 255,
    "receiver_phone": 64
  },
  "invoice_company": {
    "address": 500,
    "bank_account": 100,
    "bank_name": 200,
    "company_name": 200,
    "contact_email": 100,
    "contact_name": 100,
    "contact_phone": 30,
    "remark": 1000,
    "seal_image_url": 500,
    "tax_no": 100
  },
  "invoice_other_fee": {
    "fee_desc": 1024,
    "other_custom_field1": 255,
    "other_custom_field10": 255,
    "other_custom_field2": 255,
    "other_custom_field3": 255,
    "other_custom_field4": 255,
    "other_custom_field5": 255,
    "other_custom_field6": 255,
    "other_custom_field7": 255,
    "other_custom_field8": 255,
    "other_custom_field9": 255,
    "other_fee_name": 255
  },
  "invoice_product": {
    "product_remark": 1000
  },
  "mail_account": {
    "auth_type": 16,
    "drafts_folder": 255,
    "email": 128,
    "imap_host": 128,
    "imap_security": 16,
    "inbox_folder": 255,
    "last_error_code": 64,
    "last_error_message": 500,
    "provider_code": 32,
    "route_type": 16,
    "secret_ciphertext": 1024,
    "sent_folder": 255,
    "smtp_host": 128,
    "smtp_security": 16,
    "spam_folder": 255,
    "status": 16,
    "trash_folder": 255
  },
  "mail_approval": {
    "approval_result": 500,
    "cc_address": 2000,
    "email_title": 500,
    "is_urgent": 10,
    "password": 255,
    "remark": 1000,
    "schedule_send": 200,
    "send_email": 2000,
    "send_type": 200,
    "username": 255
  },
  "mail_group": {
    "background": 255,
    "group_name": 512,
    "parent_name": 255
  },
  "mail_group_rules": {
    "and_or": 10,
    "query_chao_is": 255,
    "query_chao_not": 255,
    "query_fa_is": 255,
    "query_fa_not": 255,
    "query_shou_is": 255,
    "query_shou_not": 255,
    "query_title": 512
  },
  "mail_info_sync": {
    "email_key": 255,
    "folder": 100,
    "folder_type": 16,
    "remote_folder": 255,
    "temp1": 255,
    "temp2": 255,
    "user_email": 255
  },
  "mail_knowledge_base": {
    "doc_format": 50,
    "doc_name": 255,
    "file_path": 1000,
    "remark": 1000
  },
  "mail_message": {
    "folder": 100,
    "from_address": 255,
    "subject": 255,
    "temp1": 200,
    "temp2": 200,
    "temp3": 200,
    "temp4": 200,
    "user_email": 255
  },
  "mail_message_user": {
    "folder": 100,
    "temp1": 200,
    "temp2": 200,
    "temp3": 200,
    "temp4": 200
  },
  "mail_quick_text": {
    "title": 500
  },
  "mail_send_plan": {
    "group_desc": 500,
    "group_name": 128,
    "mail_template_ids": 500,
    "remark": 1000
  },
  "mail_signature": {
    "title": 500
  },
  "mail_task": {
    "send_email": 255,
    "task_name": 128
  },
  "mail_task_detail_template": {
    "template_title": 1023
  },
  "mail_task_execute_record": {
    "fail_reason": 500,
    "last_error": 500,
    "lock_worker": 64,
    "receive_email": 255
  },
  "mail_task_mailbox": {
    "send_email": 255
  },
  "mail_task_reply_content": {
    "mail_from": 255,
    "mail_subject": 500,
    "mail_to": 1000,
    "receive_email": 255
  },
  "mail_temp": {
    "from_address": 255,
    "subject": 255,
    "temp1": 255,
    "temp2": 255,
    "temp3": 255,
    "temp4": 255
  },
  "mail_template": {
    "email_subject": 255,
    "remark": 1000,
    "template_name": 255
  },
  "mail_uid_sync": {
    "folder": 100,
    "folder_type": 16,
    "remote_folder": 255,
    "user_email": 255
  },
  "mail_user_bind_task": {
    "email": 255,
    "error_msg": 1000
  },
  "measure_unit": {
    "cn_name": 100,
    "en_name": 100,
    "symbol": 50,
    "unit_type": 100
  },
  "menu": {
    "component": 255,
    "creator": 64,
    "en_name": 200,
    "icon": 100,
    "menu_name": 50,
    "menu_type": 1,
    "modifier": 64,
    "path": 200,
    "permission_code": 100,
    "query": 255,
    "remark": 500,
    "status": 1,
    "visible": 1
  },
  "oper_log": {
    "dept_name": 50,
    "error_msg": 2000,
    "json_result": 2000,
    "method": 100,
    "oper_ip": 128,
    "oper_location": 255,
    "oper_name": 50,
    "oper_param": 2000,
    "oper_url": 255,
    "request_method": 10,
    "title": 50
  },
  "packing_list": {
    "address": 500,
    "consignee": 100,
    "ctn_no": 128,
    "item": 255,
    "packing_no": 64,
    "packing_time": 255,
    "phone": 64,
    "pi_no": 64,
    "po_no": 64,
    "shipping_mark": 255
  },
  "packing_list_detail": {
    "ctn_no": 255,
    "custom_field_1": 255,
    "custom_field_10": 255,
    "custom_field_2": 255,
    "custom_field_3": 255,
    "custom_field_4": 255,
    "custom_field_5": 255,
    "custom_field_6": 255,
    "custom_field_7": 255,
    "custom_field_8": 255,
    "custom_field_9": 255,
    "product_name": 255
  },
  "packing_list_progress": {
    "remark": 1000
  },
  "pai_conversation": {
    "last_model_key": 32,
    "scene_code": 64,
    "title": 200
  },
  "pai_eval_result": {
    "answer_model": 64,
    "answer_model_key": 32,
    "data_interface": 64,
    "judge_model": 64,
    "metric": 32,
    "question": 500,
    "run_id": 40
  },
  "pai_file": {
    "cos_url": 512,
    "filename": 255,
    "mime": 128,
    "storage_path": 512
  },
  "pai_message": {
    "model": 64,
    "model_key": 32,
    "provider": 32,
    "role": 16,
    "trigger_type": 16
  },
  "pai_usage_log": {
    "model": 64,
    "model_key": 32,
    "node": 24,
    "provider": 32,
    "scene_code": 32
  },
  "pai_user_email_style": {
    "email_account": 255,
    "last_error": 500,
    "model_key": 32
  },
  "po_order": {
    "currency": 20,
    "po_file": 1000,
    "po_no": 64,
    "remark": 1000,
    "summary": 1000
  },
  "product": {
    "brand": 100,
    "country_of_origin": 100,
    "customs_code": 100,
    "drawing_no": 100,
    "factory_code": 100,
    "material": 255,
    "material_en": 255,
    "oem_sale_price": 50,
    "price_range": 100,
    "primary_supplier_price_remark": 1000,
    "process_tech": 255,
    "product_category": 255,
    "product_category_en": 255,
    "product_code": 100,
    "product_cost_price": 50,
    "product_main_image": 1000,
    "product_model": 255,
    "product_model_en": 255,
    "product_name": 255,
    "product_name_en": 255,
    "product_number": 200,
    "product_short_name": 255,
    "product_sku": 100,
    "product_sku_image": 1000,
    "product_spec": 255,
    "product_spec_en": 255,
    "product_tag": 255,
    "product_unit_price": 50,
    "purchase_price": 50,
    "rebate_rate": 50,
    "regulatory_condition": 255,
    "remark": 1000,
    "spec_model": 255,
    "supplier_name": 255,
    "unit": 50,
    "vat_rate": 50
  },
  "product_ai_quote": {
    "file_ids": 1000
  },
  "product_ai_quote_supplier_info": {
    "file_ids": 1000
  },
  "product_category": {
    "name": 100,
    "remark": 1000
  },
  "product_document": {
    "doc_format": 50,
    "doc_name": 255,
    "remark": 1000
  },
  "product_field_display": {
    "api_field_name": 100,
    "field_name": 100,
    "field_sys_name": 100
  },
  "product_tag": {
    "color": 32,
    "name": 100,
    "remark": 1000
  },
  "project": {
    "project_name": 255,
    "project_no": 64
  },
  "project_after_sales_follow_record": {
    "follow_content": 4000
  },
  "project_quote_follow_record": {
    "remark": 1000
  },
  "project_risk_warning": {
    "risk_level": 20,
    "scene_group": 100,
    "scene_name": 255,
    "source_field": 255,
    "title": 255,
    "warning_type": 100
  },
  "project_stage": {
    "stage_name": 255
  },
  "project_stage_user_template": {
    "remark": 1000,
    "template_name": 255
  },
  "prompt_word": {
    "remark": 1000,
    "title": 255
  },
  "purchase_contract": {
    "contact_person": 100,
    "contract_no": 64,
    "delivery_place": 255,
    "party_a_agent_name": 100,
    "party_a_bank_account": 128,
    "party_a_bank_name": 255,
    "party_a_email": 255,
    "party_a_name": 255,
    "party_a_phone": 64,
    "party_a_tax_no": 128,
    "party_b_bank_account": 128,
    "party_b_bank_name": 255,
    "party_b_name": 255,
    "party_b_phone": 64,
    "party_b_tax_no": 128,
    "sign_place": 255,
    "supplier_contract_period": 255
  },
  "purchase_contract_attachment": {
    "doc_format": 50,
    "doc_name": 255
  },
  "purchase_contract_other_fee": {
    "custom_field1": 255,
    "custom_field10": 255,
    "custom_field2": 255,
    "custom_field3": 255,
    "custom_field4": 255,
    "custom_field5": 255,
    "custom_field6": 255,
    "custom_field7": 255,
    "custom_field8": 255,
    "custom_field9": 255,
    "fee_desc": 1024,
    "other_fee_name": 255
  },
  "purchase_order": {
    "po_no": 64,
    "remark": 1000,
    "supplier_contract_period": 255
  },
  "purchase_order_other_fee": {
    "fee_desc": 1024,
    "fee_name": 255,
    "fee_remark": 1024
  },
  "purchase_order_progress": {
    "completed_progress": 1000,
    "quality_report_file_ids": 1000
  },
  "purchase_request": {
    "lead_time": 255,
    "packaging_requirement": 500,
    "payment_method": 255,
    "price_unit": 100,
    "proforma_invoice_ids": 500,
    "purchase_request_no": 64,
    "remark": 1000,
    "validity_period": 255
  },
  "purchase_request_other_fee": {
    "fee_desc": 1024,
    "fee_name": 255,
    "fee_remark": 1024
  },
  "quotation": {
    "approval_reason": 1000,
    "approver": 255,
    "collection_method": 255,
    "currency": 20,
    "delivery_term": 255,
    "destination_port": 255,
    "fee_name": 255,
    "fee_remark": 1000,
    "incoterms": 255,
    "internal_quote_ref": 255,
    "loading_and_destination_port": 255,
    "loading_port": 255,
    "other_remark": 1000,
    "packing_method": 255,
    "payment_method": 255,
    "qty_unit": 50,
    "quote_date": 50,
    "quote_no": 64,
    "remark": 1000,
    "shipment_deadline": 255,
    "total_package_unit": 50,
    "transport_mode": 255,
    "user_defined_1": 255,
    "user_defined_10": 255,
    "user_defined_2": 255,
    "user_defined_3": 255,
    "user_defined_4": 255,
    "user_defined_5": 255,
    "user_defined_6": 255,
    "user_defined_7": 255,
    "user_defined_8": 255,
    "user_defined_9": 255,
    "validity_period": 255
  },
  "quotation_other_fee": {
    "custom_field1": 255,
    "custom_field10": 255,
    "custom_field2": 255,
    "custom_field3": 255,
    "custom_field4": 255,
    "custom_field5": 255,
    "custom_field6": 255,
    "custom_field7": 255,
    "custom_field8": 255,
    "custom_field9": 255,
    "fee_desc": 1024,
    "other_fee_name": 255
  },
  "quotation_product": {
    "product_remark": 1000,
    "user_defined_1": 255,
    "user_defined_10": 255,
    "user_defined_2": 255,
    "user_defined_3": 255,
    "user_defined_4": 255,
    "user_defined_5": 255,
    "user_defined_6": 255,
    "user_defined_7": 255,
    "user_defined_8": 255,
    "user_defined_9": 255
  },
  "quotation_quoter": {
    "quote_email": 255,
    "quote_mobile": 50,
    "quote_phone": 50,
    "quote_skype": 100,
    "quote_user": 100,
    "quote_whatsapp": 100
  },
  "quote_request": {
    "attachment_ids": 1000,
    "cannot_quote_reason": 1000,
    "quote_request_no": 64,
    "remark": 1000
  },
  "role": {
    "creator": 64,
    "modifier": 64,
    "remark": 500,
    "role_key": 100,
    "role_name": 30,
    "status": 1,
    "type": 1
  },
  "supplier": {
    "bank_account": 128,
    "bank_name": 255,
    "city": 100,
    "company_address": 500,
    "company_phone": 64,
    "main_business": 255,
    "remark": 1000,
    "supplier_code": 64,
    "supplier_name": 255,
    "tax_no": 128
  },
  "supplier_contact": {
    "name": 100,
    "phone": 50,
    "remark": 1000
  },
  "supplier_document": {
    "doc_format": 50,
    "doc_name": 255,
    "doc_path": 1000,
    "remark": 1000
  },
  "supplier_quote": {
    "price_unit": 64,
    "supplier_quote_no": 64
  },
  "supplier_quote_other_fee": {
    "fee_desc": 1024,
    "fee_name": 255,
    "fee_remark": 1024
  },
  "supplier_quote_supplier": {
    "lead_time": 255,
    "packaging_requirement": 255,
    "payment_method": 255,
    "price_total": 255,
    "validity_period": 255
  },
  "supplier_quote_supplier_detail": {
    "custom_field1": 255,
    "custom_field2": 255,
    "custom_field3": 255,
    "custom_field4": 255,
    "custom_field5": 255,
    "custom_field6": 255,
    "file_path": 1024,
    "packaging_transport_price": 255,
    "raw_material_price": 255
  },
  "supplier_rating": {
    "create_user_id": 64,
    "name": 100,
    "remark": 1000
  },
  "task_follow_up_progress": {
    "attachment_paths": 2000,
    "problem_solution": 2000,
    "progress_desc": 2000
  },
  "task_info": {
    "remark": 1000,
    "task_title": 255
  },
  "used_client_email": {
    "client_email": 500
  },
  "user": {
    "avatar": 100,
    "creator": 64,
    "email": 50,
    "login_ip": 128,
    "login_name": 30,
    "modifier": 64,
    "password": 100,
    "phonenumber": 50,
    "remark": 500,
    "risk_receiver_user_ids": 255,
    "sex": 1,
    "status": 1,
    "user_name": 30,
    "user_type": 2
  },
  "user_mail": {
    "email": 50,
    "email_key": 50,
    "remark": 2000
  },
  "user_mail_approval_rule": {
    "creator": 64,
    "default_cc_email": 255,
    "modifier": 64,
    "week_days": 32
  },
  "version_update_record": {
    "remark": 500,
    "title": 255,
    "version_no": 100
  },
  "wa_account": {
    "display_name": 64,
    "phone": 32,
    "session_key": 64,
    "status": 16
  },
  "wa_chat": {
    "jid": 64,
    "last_text": 1024,
    "name": 128
  },
  "wa_contact": {
    "jid": 64,
    "name": 128
  },
  "wa_jid_map": {
    "lid": 64,
    "phone": 64
  },
  "wa_message": {
    "chat_jid": 64,
    "media_url": 512,
    "msg_type": 24,
    "push_name": 128,
    "sender": 64,
    "wa_msg_id": 128
  },
  "work_report": {
    "report_title": 200,
    "submit_user_name": 64
  },
  "work_report_delivery": {
    "message_title": 200
  },
  "work_report_delivery_item": {
    "submit_user_name": 64
  },
  "xxl_job_group": {
    "app_name": 64,
    "title": 12
  },
  "xxl_job_info": {
    "alarm_email": 255,
    "author": 64,
    "child_jobid": 255,
    "executor_block_strategy": 50,
    "executor_handler": 255,
    "executor_param": 512,
    "executor_route_strategy": 50,
    "glue_remark": 128,
    "glue_type": 50,
    "job_desc": 255,
    "misfire_strategy": 50,
    "schedule_conf": 128,
    "schedule_type": 50
  },
  "xxl_job_lock": {
    "lock_name": 50
  },
  "xxl_job_log": {
    "executor_address": 255,
    "executor_handler": 255,
    "executor_param": 512,
    "executor_sharding_param": 20
  },
  "xxl_job_logglue": {
    "glue_remark": 128,
    "glue_type": 50
  },
  "xxl_job_registry": {
    "registry_group": 50,
    "registry_key": 255,
    "registry_value": 255
  },
  "xxl_job_user": {
    "password": 100,
    "permission": 255,
    "token": 100,
    "username": 50
  }
}

export default DB_FIELD_LENGTH_MAP
